import React from "react";
import {
  LedgerStatementType,
  TotalDebitCreditAmountType,
} from "../../../../redux/reports/reportsType";
import {  TableLoader } from "../../../commons";
import LedgerStatementTableHeader from "./LedgerStatementTableHeader";
import LedgerStatementTableData from "./LedgerStatementTableData";
import ScrollToTop from "../../../commons/ScrollToTop";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import { currencySignAndNegativeValueAdjust } from "../../../../utils/commonFunctions";

type AppProps = {
  ledgerStatementData: [] | LedgerStatementType[];
  reportsFetching: boolean;
  client_code: number;
  company_name: string;
  handleManageRedirectToInvoice: (invoiceType: number) => void;
  handleCustomerSuplierDetailsData: (invoiceType: number) => void;
  offset: number;
  currencySign: string;
  closingBalance: number;
  openingBalance: number;
  totalDebitCreditAmount: TotalDebitCreditAmountType;
};

const LedgerStatementTable = ({
  ledgerStatementData,
  client_code,
  reportsFetching,
  company_name,
  handleManageRedirectToInvoice,
  handleCustomerSuplierDetailsData,
  offset,
  currencySign,
  closingBalance,
  openingBalance,
  totalDebitCreditAmount,
}: AppProps) => {
  return (
    <>
      {reportsFetching && offset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={8} />
      ) : (
        <div className="jobsType">
          <table className="table table-bordered thead-light">
            <thead className="text-start sticky-table-header-without-zindex">
              <LedgerStatementTableHeader />
              <tr>
                <th
                  colSpan={6}
                  style={{
                    backgroundColor: "#E8EBF0",
                    textAlign: "end",
                    borderColor: "#E8EBF0",
                    fontSize: "13px",
                  }}
                >
                  <span className="mr-2">OPENING BALANCE</span>
                </th>
                <th
                  colSpan={3}
                  style={{
                    backgroundColor: "#E8EBF0",
                    borderColor: "#E8EBF0",
                    fontSize: "13px",
                  }}
                >
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    openingBalance
                      ? openingBalance?.toFixed(2)?.toString()
                      : "0"
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              <LedgerStatementTableData
                ledgerStatementData={ledgerStatementData}
                client_code={client_code}
                company_name={company_name}
                currencySign={currencySign}
                handleManageRedirectToInvoice={handleManageRedirectToInvoice}
                handleCustomerSuplierDetailsData={
                  handleCustomerSuplierDetailsData
                }
              />
              <tr>
                <td
                  colSpan={6}
                  style={{
                    backgroundColor:
                      ledgerStatementData?.length === 0 && openingBalance !== 0
                        ? "rgb(198 201 207)"
                        : "#E8EBF0",
                    textAlign: "end",
                    borderColor:
                      ledgerStatementData?.length === 0 && openingBalance !== 0
                        ? "rgb(198 201 207)"
                        : "#E8EBF0",
                    fontWeight: "bold",
                    color: "#464f60",
                    fontSize: "13px",
                  }}
                >
                  <span className="mr-2">CLOSING BALANCE</span>
                </td>
                <td
                  colSpan={3}
                  style={{
                    backgroundColor:
                      ledgerStatementData?.length === 0 && openingBalance !== 0
                        ? "rgb(198 201 207)"
                        : "#E8EBF0",
                    borderColor:
                      ledgerStatementData?.length === 0 && openingBalance !== 0
                        ? "rgb(198 201 207)"
                        : "#E8EBF0",
                    fontWeight: "bold",
                    color: "#464f60",
                    fontSize: "13px",
                  }}
                >
                  {currencySignAndNegativeValueAdjust(
                    currencySign,
                    closingBalance
                      ? closingBalance?.toFixed(2)?.toString()
                      : "0"
                  )}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={4}
                  style={{
                    backgroundColor: "#262A45",
                    textAlign: "end",
                    borderColor: "#262A45",
                    fontSize: "13px",
                  }}
                >
                  <span className="mr-2" style={{ color: "white" }}>
                    TOTAL DEBIT & CREDIT
                  </span>
                </td>
                <td
                  colSpan={1}
                  style={{
                    backgroundColor: "#262A45",
                    textAlign: "left",
                    borderColor: "#262A45",
                    fontSize: "13px",
                    color: "#67cb9c",
                  }}
                >
                  <span className="text-left">
                    {currencySignAndNegativeValueAdjust(
                      currencySign,
                      totalDebitCreditAmount?.total_debit_amount
                        ? totalDebitCreditAmount?.total_debit_amount
                            ?.toFixed(2)
                            ?.toString()
                        : "0"
                    )}
                  </span>
                </td>
                <td
                  colSpan={4}
                  style={{
                    backgroundColor: "#262A45",
                    textAlign: "left",
                    borderColor: "#262A45",
                    color: "#f17c7c",
                    fontSize: "13px",
                  }}
                >
                  <span className="text-left">
                    {currencySignAndNegativeValueAdjust(
                      currencySign,
                      totalDebitCreditAmount?.total_credit_amount
                        ? totalDebitCreditAmount?.total_credit_amount
                            ?.toFixed(2)
                            ?.toString()
                        : "0"
                    )}
                  </span>
                </td>
              </tr>
              <div style={{ display: reportsFetching ? "none" : "inline" }}>
                <ScrollToTop />
              </div>
              {reportsFetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default LedgerStatementTable;
